import { useState, useEffect } from "react";

// Theme
import { useTheme } from "@mui/material/styles";

// Component
import useMediaQuery from "@mui/material/useMediaQuery";

const useDevice = () => {
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.up("xs"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));

  const [device, setDevice] = useState("");

  const getDevice = () => {
    if (sm && md && lg && xl) return "pc";
    if (sm && md && !lg && !xl) return "tablet";
    if (!sm && !md && !lg && !xl && xs) return "mobile";
  };

  useEffect(() => {
    setDevice(getDevice());
  }, [sm, md, lg, xl, xs]);

  return { device };
};

export default useDevice;
